export enum Triggers {
  leadCreate = 'lead_create',
  leadUpdate = 'lead_update',
  leadActivityCreate = 'lead_activity_create',
  leadActivityUpdate = 'lead_activity_update',
  taskBaseCreate = 'task/base_create',
  userCreate = 'user_create',
  userUpdate = 'user_update',
  dealCreate = 'deal_create',
  dealUpdate = 'deal_update',
}

export enum ConditionTypes {
  ifElse = 'if_else',
  if = 'if',
  wait = 'wait',
  multiIfElse = 'multi_if_else',
  else = 'else',
  compare = 'compare',
}

export enum ActionTypes {
  updateLead = 'update_lead',
  webhook = 'webhook',
  distributeLead = 'distribute_lead',
  sendEmail = 'send_email',
  createTask = 'create_task',
  completeTask = 'complete_task',
  addLeadActivity = 'add_lead_activity',
}

export interface TriggersConfig {
  name: Triggers;
  executor: string;
  node_type: string;
  group_name: string;
  desc?: string;
}

export interface ConditionsConfig {
  name: ConditionTypes;
  executor: string;
  desc: string;
}

export interface ActionsConfig {
  name: ActionTypes;
  executor: string;
  desc: string;
}

export interface AutomationConfig {
  triggers: TriggersConfig[];
  conditions: ConditionsConfig[];
  actions: ActionsConfig[];
}
